// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f120a2b6","455":"36c886a2","977":"b89c3a2b"}[chunkId] + ".chunk.js";
};